import dayjs from 'dayjs';
import 'dayjs/locale/nb';

dayjs.locale('nb');

let moneyFormatter = new Intl.NumberFormat('nb-NO', {
    style: 'currency', currency: 'NOK'
});

let numberFormatter = new Intl.NumberFormat('nb-NO', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

export function formatMoney(value) {
    if (!value && value !== 0) return null;
    return moneyFormatter.format(value);
}

export function formatNumber(value) {
    if (!value && value !== 0) return null;
    return numberFormatter.format(value);
}

export function formatTime(value) {
    if (!value) return null;
    return dayjs(value).format('HH:mm, D. MMMM YYYY');
}
export function formatDate(value) {
    if (!value) return null;
    return dayjs(value).format('DD.MM.YYYY');
}